// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
// Component imports
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class StaticPageModule {
}
StaticPageModule.ɵfac = function StaticPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StaticPageModule)(); };
StaticPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StaticPageModule, bootstrap: [TopBarNavComponent] });
StaticPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, ConfigModule, NavigationModule, StoreModule.forRoot({})] });
